import { render, staticRenderFns } from "./wxtotal.vue?vue&type=template&id=10f76bf3&scoped=true&"
import script from "./wxtotal.vue?vue&type=script&lang=js&"
export * from "./wxtotal.vue?vue&type=script&lang=js&"
import style0 from "./wxtotal.vue?vue&type=style&index=0&id=10f76bf3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f76bf3",
  null
  
)

export default component.exports